module.exports = __webpack_public_path__ + "img/slack.82243505.svg";